import type { LanguageUpdateCurrentBody } from "@core/data/dto/update-current-language.dto.ts";
import { LanguageIsoCodeEnumMapper } from "@core/data/mappers/language-iso-code-enum.mapper";
import { LanguageIsoCodeEnum } from "@core/domain/models/language.model";
import { inject, injectable } from "inversify";

@injectable()
export class LanguageUpdateCurrentMapper {
    constructor(
        @inject(LanguageIsoCodeEnumMapper)
        private readonly languageIsoCodeEnumMapper: LanguageIsoCodeEnumMapper,
    ) {}

    mapToDto(language: LanguageIsoCodeEnum): LanguageUpdateCurrentBody {
        const languageDto = this.languageIsoCodeEnumMapper.mapToDto(language);
        return { locale: languageDto };
    }
}
